window.API_LOCATION = document.domain;
window.API_WEBSOCKET = 'lptstart.ru';
window.PRODUCTION=true